import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import SuTransactionListPageUI from './SuTransactionListPageUI.js'
import { getYearList } from '../../../components/common/GetYearList'
import LocalStorageKeys from '../../../cache/LocalStorageKeys'

class SuTransactionListPageSF extends Component {
  constructor(props) {
    super(props)
    const { yearList, year, period } = getYearList()
    this.state = {
      yearList,
      year,
      period,
      errorList: null,
      txnList: null,
      filteredTxnList: null,
      bankAccountList: null,
      periodList: [],
      searchFilter: '',
      bankAccountNumber: null,
      copyToClipboardText: null,
      currentPage: 1,
      pageSize: 20,
      filteredTxnList: null,
      details: false,
      hasMore: true,
      gettingMore: false,
      downloadMode: false,
      nachFileUploadMode: false,
      uploadTraditionalEscrowMode: false,
      uploadTraditionalEscrowErrorList: [],
      transactionTypeUpdated: false
    }
  }

  render() {
    // let yearList = [
    //   { value: '2022', label: '2022' },
    //   { value: '2023', label: '2023' },
    //   { value: '2024', label: '2024' },
    //   { value: '2025', label: '2025' },
    // ]
    const paginatedTxnList = this.getPaginatedTransactions()
    let periodList = [
      { value: 'Q1', label: 'Q1' },
      { value: 'Q2', label: 'Q2' },
      { value: 'Q3', label: 'Q3' },
      { value: 'Q4', label: 'Q4' },
      { value: 'YEAR', label: 'Full year' },
    ]
    return (
      <SuTransactionListPageUI
        context={this.props.context}
        account={this.state.account}
        errorList={this.state.errorList}
        filteredTxnList={this.state.filteredTxnList}
        bankAccountList={this.state.bankAccountList}
        onRefreshClick={this.onRefreshClick}
        searchFilter={this.state.searchFilter}
        onSearchFilterChange={this.onSearchFilterChange}
        copyToClipboardText={this.state.copyToClipboardText}
        onCopyToClipboard={this.onCopyToClipboard}
        // details
        details={this.state.details}
        onDetailsClick={() => { this.setState({ details: !this.state.details }) }}
        // pagination
        txnList={paginatedTxnList}
        currentPage={this.state.currentPage}
        pageSize={this.state.pageSize}
        totalCount={this.state.filteredTxnList ? this.state.filteredTxnList.length : 0}
        hasMore={this.state.hasMore}
        onMoreTransactions={this.onMoreTransactions}
        gettingMore={this.state.gettingMore}
        onNextPage={this.goToNextPage}
        onPreviousPage={this.goToPreviousPage}
        // Download
        downloadMode={this.state.downloadMode}
        onDownloadClick={() => { this.setState({ downloadMode: true }) }}
        onDownloadCancel={() => { this.setState({ downloadMode: false }) }}
        bankAccountNumber={this.props.match.params.bankAccountId || this.state.bankAccountList && this.state.bankAccountList[0].bankAccountNumber}
        // upload
        nachFileUploadMode={this.state.nachFileUploadMode}
        onNachFileUploadClick={() => { this.setState({ nachFileUploadMode: true }) }}
        onNachFileUploadCancel={() => { this.setState({ nachFileUploadMode: false }) }}
        onNachFileUpload={this.onNachFileUpload}
        nachFileUploadErrorList={this.state.nachFileUploadErrorList}
        //
        periodList={periodList}
        yearList={this.state.yearList}

        year={this.state.year}
        period={this.state.period}
        onYearChange={this.onYearChange}
        onPeriodChange={this.onPeriodChange}
        //
        uploadTraditionalEscrowMode={this.state.uploadTraditionalEscrowMode}
        onUploadTraditionalEscrowClick={() => { this.setState({ uploadTraditionalEscrowMode: true }) }}
        onCancelTraditionalEscrowClick={() => { this.setState({ uploadTraditionalEscrowMode: false }) }}
        onTraditionalEscrowUpload={this.onTraditionalEscrowUpload}
        uploadTraditionalEscrowErrorList={this.state.uploadTraditionalEscrowErrorList}
        //
        transactionTypeUpdated={this.state.transactionTypeUpdated}
        onTransactionTypeUpdateClick={this.onTransactionTypeUpdateClick}
        onTransactionTypeCancelClick={() => { this.setState({ transactionTypeUpdated: false }) }}
        selectedTransactionId={this.state.selectedTransactionId}
      />
    )
  }



  onTransactionTypeUpdateClick = (event) => {
    let transactionId = event.currentTarget.getAttribute('data-id')
    this.setState({ transactionTypeUpdated: true, selectedTransactionId: transactionId })
  }

  componentDidMount() {
    let context = this.props.context
    
    this.getAccounts(context)
    this.getBankAccounts(context)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.bankAccountId == this.props.match.params.bankAccountId)
      return

    let context = this.props.context
    this.getBankAccounts(context)
  }

  getBankAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/bankAccounts`,
      cacheKey: CacheKeys.BankAccounts(this.props.match.params.accountId),
      callback: this.getBankAccountsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getBankAccountsCallback = (response) => {
    let bankAccountNumber = this.props.match.params.bankAccountId || response.bankAccountList[0].bankAccountNumber
    this.setState(
      {
        bankAccountList: response.bankAccountList,
        bankAccountNumber: bankAccountNumber,
        errorList: response.errorList
      }, () => {
        this.getTransactions(this.props.context, bankAccountNumber, this.state.year, this.state.period)
      }
    )
  }

  getTransactions(context, bankAccountNumber, year, period) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.state.account.accountId}/virtualAccounts/${bankAccountNumber}/transactions?year=${year}&period=${period}`,
      cacheKey: CacheKeys.Transactions2(this.props.match.params.accountId, bankAccountNumber, year, period),
      callback: this.getTransactionsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  // getTransactionsCallback = (response) => {
  //   let bankAccountNumber = this.props.match.params.bankAccountId || this.state.bankAccountList[0].bankAccountNumber

  //   let filtersStr = sessionStorage.getItem(CacheKeys.Transactions2Filter(this.props.match.params.accountId, bankAccountNumber))
  //   let filters = filtersStr ? JSON.parse(filtersStr) : {}

  //   this.setState({
  //     errorList: response.errorList,
  //     txnList: response.transactionList,
  //     year: response.year,
  //     period: response.period,
  //     filteredTxnList: response.transactionList,
  //     searchFilter: filters.searchFilter ? filters.searchFilter : '',
  //     currentPage: response.currentPage,
  //     hasMore: response.hasMore
  //   })

  //   this.applyFilters(response.transactionList, filters.searchFilter ? filters.searchFilter : '')
  // }


  getTransactionsCallback = (response) => {
    let bankAccountNumber = this.props.match.params.bankAccountId || this.state.bankAccountList[0].bankAccountNumber

    let filtersStr = sessionStorage.getItem(CacheKeys.Transactions2Filter(this.props.match.params.accountId, bankAccountNumber))
    let filters = filtersStr ? JSON.parse(filtersStr) : {}

    const filteredTxnList = this.applyFilters(response.transactionList, filters.searchFilter ? filters.searchFilter : '', true) // third param true = reset page

    const maxPage = Math.ceil(filteredTxnList.length / this.state.pageSize)
    this.setState({
      errorList: response.errorList,
      txnList: response.transactionList,
      filteredTxnList: filteredTxnList,
      searchFilter: filters.searchFilter ? filters.searchFilter : '',
      currentPage: 1,
      hasMore: maxPage > 1
    })
  }

  getPaginatedTransactions = () => {
    const { filteredTxnList, currentPage, pageSize } = this.state
    if (!filteredTxnList) return []
    const startIndex = (currentPage - 1) * pageSize
    const endIndex = startIndex + pageSize
    return filteredTxnList.slice(startIndex, endIndex)
  }

  // NEW: go to next page
  goToNextPage = () => {
    const { currentPage, filteredTxnList, pageSize } = this.state
    const maxPage = Math.ceil(filteredTxnList.length / pageSize)
    if (currentPage < maxPage) {
      this.setState({ currentPage: currentPage + 1, hasMore: currentPage + 1 < maxPage })
    }
  }

  // NEW: go to previous page
  goToPreviousPage = () => {
    const { currentPage, filteredTxnList, pageSize } = this.state
    if (currentPage > 1) {
      const maxPage = Math.ceil(filteredTxnList.length / pageSize)
      this.setState({ currentPage: currentPage - 1, hasMore: currentPage < maxPage })
    }
  }



  onYearChange = (option) => {
    let context = this.props.context
    this.setState({ year: option.value })
    this.getTransactions(context, this.state.bankAccountNumber, option.value, this.state.period)
  }

  onPeriodChange = (option) => {
    let context = this.props.context
    this.setState({ period: option.value })
    this.getTransactions(context, this.state.bankAccountNumber, this.state.year, option.value)
  }

  onCopyToClipboard = (text, result) => {
    this.setState({ copyToClipboardText: text })
    setTimeout(() => {
      this.setState({ copyToClipboardText: null })
    }, 3000)
  }

  // method not used; need different impl for DDB
  // onMoreTransactions = () => {
  //   let context = this.props.context
  //   this.setState({ gettingMore: true })

  //   RestApiUtils.get(
  //     this.props.context,
  //     `/api/accounts/${this.props.match.params.accountId}/bankAccounts/${this.props.match.params.bankAccountId}/transactions`,
  //     this.onMoreTransactionsCallback,
  //     null,
  //     { requestedPage: this.state.currentPage + 1 }
  //   )
  // }

  onMoreTransactionsCallback = (response) => {
    let context = this.props.context
    let txnList = this.state.txnList
    response.transactionList = txnList.concat(response.transactionList)

    let filtersStr = sessionStorage.getItem(CacheKeys.Transactions2Filter(this.props.match.params.accountId, this.props.match.params.bankAccountId))
    let filters = filtersStr ? JSON.parse(filtersStr) : {}

    this.setState({
      errorList: response.errorList,
      txnList: response.transactionList,
      filteredTxnList: response.transactionList,
      searchFilter: filters.searchFilter ? filters.searchFilter : '',
      currentPage: response.currentPage,
      hasMore: response.hasMore,
      gettingMore: false
    })

    CacheManager.setObject(CacheKeys.Transactions2(this.props.match.params.accountId, this.props.match.params.bankAccountId), response)

    this.applyFilters(response.transactionList, filters.searchFilter ? filters.searchFilter : '')
  }

  applyFilters(txnList, searchFilter, resetPage = false) {
    let filteredList = txnList

    if (searchFilter)
      filteredList = filteredList.filter(txn =>
        txn.type && txn.type.includes(searchFilter.toLocaleLowerCase()) ||
        txn.narration && txn.narration.toLocaleLowerCase().includes(searchFilter.toLocaleLowerCase()) ||
        txn.payee && txn.payee.toLocaleLowerCase().includes(searchFilter.toLocaleLowerCase())
      )

    if (resetPage) this.setState({ currentPage: 1 })

    return filteredList
  }

  onNachFileUpload = (fileId, fileName, fileType, fileSize) => {
    this.setState({ nachFileUploadSubmitted: true })
    RestApiUtils.post(this.props.context,
      `/api/su/nach/transactions/validation`,
      this.onNachFileUploadCallback, {
      fileUpload: {
        fileId: fileId,
        fileName: fileName,
        fileType: fileType,
        fileSize: fileSize
      }
    }
    )
  }


  onNachFileUploadCallback = (response) => {
    this.setState({ nachFileUploadSubmitted: false })
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    if (errorList.length) {
      this.setState({
        nachFileUploadErrorList: errorList
      })
      return
    }

    this.setState({
      nachFileUploadSuccessMsg: response.success,
      nachFileUploadErrorList: errorList,
    })

    this.onRefreshClick()

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          nachFileUploadSuccessMsg: null
        })
      }, 2000)
    }
  }

  onTraditionalEscrowUpload = (fileId, fileName, fileType, fileSize) => {
    this.setState({ traditionalEscrowUploadSubmitted: true })
    RestApiUtils.post(this.props.context,
      `/api/su/accounts/${this.props.match.params.accountId}/escrowAccounts/${this.state.bankAccountNumber}/validation`,
      this.onTraditionalEscrowUploadCallback, {
      fileUpload: {
        fileId: fileId,
        fileName: fileName,
        fileType: fileType,
        fileSize: fileSize
      }
    }
    )
  }

  onTraditionalEscrowUploadCallback = (response) => {
    this.setState({ traditionalEscrowUploadSubmitted: false })
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    if (errorList.length) {
      this.setState({
        uploadTraditionalEscrowErrorList: errorList
      })
      return
    }

    this.setState({
      traditionalEscrowUploadSuccessMsg: response.success,
      uploadTraditionalEscrowErrorList: errorList,
    })

    this.onRefreshClick()

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          traditionalEscrowUploadSuccessMsg: null
        })
      }, 2000)
    }
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountsCallback = (response) => {
    this.setState({ account: response.account })
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Transactions2(this.props.match.params.accountId,
      this.state.bankAccountNumber, this.state.year, this.state.period))
    this.setState({
      errorList: null,
      txnList: null,
      filteredTxnList: null,
    }, () => {
      this.getBankAccounts(context)
    })
  }

  onSearchFilterChange = (event) => {
    let searchFilter = event.target.value
    this.setState({ searchFilter: searchFilter })
    this.applyFilters(this.state.txnList, searchFilter)
  }
}

export default withRouter(SuTransactionListPageSF)
